/* @flow */

import ReactGA from 'react-ga';
import _ from 'lodash';
import { takeEvery, call, all, fork } from 'redux-saga/effects';
import { constants } from '../actions/design';

type SagaActionType = {
  '@@redux-saga/SAGA_ACTION'?: boolean,
  payload: Object,
  silent?: boolean,
  type: string,
};

const listenToActions = [
  constants.STEP_FORWARD, constants.STEP_BACKWARD, constants.STEP_RESET,
  constants.AUTO_COMPLETE, constants.RENAME_DESIGN, constants.NEW_DESIGN,
  constants.EVALUATE, constants.JUMP_STEP, constants.DOWNLOAD_PDF,
  constants.DOWNLOAD_SCHEMATIC, constants.EXPORT_BOM_EXCEL, constants.SAVE_DESIGN,
  constants.RECEIVE_DESIGN, constants.RECEIVE_USER, constants.OPEN_DESIGN,
];

export function* watchAnalytics(): Generator<*, *, *> {
  yield takeEvery(listenToActions, (action: SagaActionType) => {
    try {
      const { type, payload, silent } = action;
      switch (type) {
        case constants.AUTO_COMPLETE: {
          ReactGA.event({ category: 'User', action: 'Autocomplete' });
          break;
        }

        case constants.SAVE_DESIGN: {
          ReactGA.event({ category: 'User', action: 'Save Design' });
          break;
        }

        case constants.RECEIVE_DESIGN: {
          ReactGA.event({ category: 'User', action: 'Open Design' });
          break;
        }

        case constants.DOWNLOAD_PDF: {
          ReactGA.event({ category: 'User', action: 'Download PDF' });
          break;
        }

        case constants.EXPORT_BOM_EXCEL: {
          ReactGA.event({ category: 'User', action: 'Download BOM' });
          break;
        }

        case constants.DOWNLOAD_SCHEMATIC: {
          ReactGA.event({ category: 'User', action: 'Download Schematic' });
          break;
        }

        case constants.RECEIVE_USER: {
          ReactGA.set({ userId: payload.data.id });
          break;
        }

        case constants.STEP_RESET: {
          ReactGA.event({ category: 'User', action: 'Reset Step' });
          break;
        }

        case constants.STEP_FORWARD: {
          ReactGA.event({ category: 'Navigation', action: 'Step Forward' });
          break;
        }

        case constants.STEP_BACKWARD: {
          ReactGA.event({ category: 'Navigation', action: 'Step Backward' });
          break;
        }

        case constants.EVALUATE: {
          const { field, value } = payload;
          const label = _.isString(value) ? 'label' : 'value';
          ReactGA.event({ category: 'Evaluation', action: field, [label]: value });
          break;
        }

        case constants.NEW_DESIGN: {
          if (payload) break;
          ReactGA.event({ category: 'User', action: 'New Design' });
          break;
        }

        case constants.JUMP_STEP: {
          if (silent) break;
          ReactGA.event({ category: 'Navigation', action: 'Change Step', label: payload });
          break;
        }

        case constants.OPEN_DESIGN: {
          ReactGA.modalview('open-designs');
          break;
        }

        default: {
          break;
        }
      }
    } catch (e) {
      console.log(e); // eslint-disable-line no-console
    }
  });
}

export default function* initializeAnalytics(): Generator<*, *, *> {
  yield all([
    call(ReactGA.initialize, `${process.env.REACT_APP_TRACKING_ID}`, { debug: true }),
    fork(watchAnalytics),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/analytics.js